/* slm-home.js : home silumen.com (refonte 11/2026, v5)
   Sélection produits en onglets, carrousels produits avec la carte de la fiche produit, prix HT/TTC.
   Même comportement que la carte de la fiche produit (silumen-produits-compatibles) :
   ajout rapide, sélecteur − 1 + synchronisé avec le panier, panneau d'options,
   prix HT/TTC (convention Silumen : #taxToggleAll / localStorage 'taxToggleAll').
   Textes et routes : window.SLM_HOME_T (rendu en Liquid par la section). */
(function () {
  'use strict';
  if (window.__slmHomeInit) return;
  window.__slmHomeInit = true;

  var T = window.SLM_HOME_T || {};
  var LOCALE = T.locale || document.documentElement.lang || 'fr';
  var CUR = T.currency || 'EUR';
  var ADD_URL = T.addUrl || '/cart/add.js';
  var CHANGE_URL = T.changeUrl || '/cart/change.js';
  var CART_URL = T.cartUrl || '/cart.js';
  var nf;
  try { nf = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CUR }); }
  catch (e) { nf = new Intl.NumberFormat('fr', { style: 'currency', currency: 'EUR' }); }
  function fmt(c) { return nf.format((c || 0) / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }

  var roots = [];
  var cartMap = {};

  /* ---------- HT / TTC ---------- */
  function isHT() {
    var tg = document.getElementById('taxToggleAll');
    if (tg) return !tg.checked;
    var v = null;
    try { v = localStorage.getItem('taxToggleAll'); } catch (e) {}
    return v === 'false';
  }
  function applyTax() {
    var ht = isHT();
    roots.forEach(function (root) {
      root.querySelectorAll('.slm-compat-price, .slm-compat-compare').forEach(function (el) {
        var v = el.getAttribute(ht ? 'data-ht' : 'data-ttc');
        if (v) el.textContent = fmt(parseInt(v, 10));
      });
      root.querySelectorAll('.slm-compat-tax').forEach(function (el) { el.textContent = ht ? T.ht : T.ttc; });
      root.querySelectorAll('.slm-compat-option-price').forEach(function (el) {
        var v = el.getAttribute(ht ? 'data-ht' : 'data-ttc');
        if (v) el.textContent = fmt(parseInt(v, 10)) + ' ' + (ht ? T.ht : T.ttc);
      });
    });
  }

  /* ---------- Markup CTA ---------- */
  function addBtnHtml() { return '<button type="button" class="slm-compat-add">' + esc(T.add) + '</button>'; }
  function chooseBtnHtml() { return '<button type="button" class="slm-compat-add slm-compat-add--choose">' + esc(T.choose) + '</button>'; }
  function stepperHtml(q) {
    return '<div class="slm-compat-stepper">'
      + '<button type="button" class="slm-compat-step" data-step="-1" aria-label="' + esc(T.dec) + '">−</button>'
      + '<input type="text" class="slm-compat-qty" inputmode="numeric" value="' + q + '" aria-label="' + esc(T.qty) + '">'
      + '<button type="button" class="slm-compat-step" data-step="1" aria-label="' + esc(T.inc) + '">+</button>'
      + '</div>';
  }
  function slotOf(cta) { return cta.querySelector('.slm-compat-cta-slot'); }

  /* ---------- Panier ---------- */
  function refreshCartMap() {
    return fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartMap = {};
        (cart.items || []).forEach(function (it) {
          if (cartMap[it.variant_id]) cartMap[it.variant_id].qty += it.quantity;
          else cartMap[it.variant_id] = { key: it.key, qty: it.quantity };
        });
      })
      .catch(function () {});
  }
  function syncCtas() {
    roots.forEach(function (root) {
      root.querySelectorAll('.slm-compat-cta').forEach(function (cta) {
        var slot = slotOf(cta);
        if (!slot) return;
        var hasOpts = cta.hasAttribute('data-has-options');
        var vid = cta.getAttribute('data-variant-id');
        if (!vid && hasOpts) {
          var opts = cta.querySelectorAll('.slm-compat-option[data-variant-id]');
          for (var i = 0; i < opts.length; i++) {
            var ov = opts[i].getAttribute('data-variant-id');
            if (cartMap[ov] && cartMap[ov].qty > 0) { vid = ov; cta.setAttribute('data-variant-id', vid); break; }
          }
        }
        if (!vid) return;
        var q = cartMap[vid] ? cartMap[vid].qty : 0;
        var input = slot.querySelector('.slm-compat-qty');
        if (q > 0) {
          if (input) { if (document.activeElement !== input) input.value = q; }
          else slot.innerHTML = stepperHtml(q);
        } else if (!slot.querySelector('.slm-compat-add')) {
          slot.innerHTML = hasOpts ? chooseBtnHtml() : addBtnHtml();
          if (hasOpts) cta.removeAttribute('data-variant-id');
        }
      });
    });
  }
  function notifyCart() { document.dispatchEvent(new CustomEvent('ajaxProduct:added')); }

  function quickAdd(vid, cta) {
    var slot = slotOf(cta);
    cta.classList.add('is-loading');
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (item) {
        var prev = cartMap[vid] || {};
        cartMap[vid] = { key: item && item.key ? item.key : prev.key, qty: item && item.quantity ? item.quantity : (prev.qty || 0) + 1 };
        slot.innerHTML = stepperHtml(cartMap[vid].qty);
        cta.classList.remove('is-loading');
        notifyCart();
      })
      .catch(function () { cta.classList.remove('is-loading'); });
  }
  function doChange(vid, qty, cta) {
    var entry = cartMap[vid];
    if (!entry || !entry.key) { cta.classList.remove('is-loading'); return; }
    cta.classList.add('is-loading');
    fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify({ id: entry.key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var q = 0, key = null;
        (cart.items || []).forEach(function (it) {
          if (String(it.variant_id) === String(vid)) { q += it.quantity; if (!key) key = it.key; }
        });
        cta.classList.remove('is-loading');
        var slot = slotOf(cta);
        if (q > 0) {
          cartMap[vid] = { key: key, qty: q };
          var input = slot.querySelector('.slm-compat-qty');
          if (input) input.value = q; else slot.innerHTML = stepperHtml(q);
        } else {
          delete cartMap[vid];
          if (cta.hasAttribute('data-has-options')) { slot.innerHTML = chooseBtnHtml(); cta.removeAttribute('data-variant-id'); }
          else slot.innerHTML = addBtnHtml();
        }
        notifyCart();
      })
      .catch(function () { cta.classList.remove('is-loading'); });
  }
  function changeQty(vid, qty, cta) {
    if (!vid) return;
    if (qty < 0) qty = 0;
    if (!cartMap[vid] || !cartMap[vid].key) {
      cta.classList.add('is-loading');
      refreshCartMap().then(function () { doChange(vid, qty, cta); });
      return;
    }
    doChange(vid, qty, cta);
  }
  function closeAll(except) {
    roots.forEach(function (root) {
      root.querySelectorAll('.slm-compat-options').forEach(function (o) { if (o !== except) o.hidden = true; });
    });
  }

  /* ---------- Interactions ---------- */
  function bind(root) {
    root.addEventListener('click', function (e) {
      var t = e.target;
      var choose = t.closest('.slm-compat-add--choose');
      if (choose) {
        e.preventDefault();
        var ov = choose.closest('.slm-compat-cta').querySelector('.slm-compat-options');
        if (ov) { var open = ov.hidden; closeAll(ov); ov.hidden = !open; }
        return;
      }
      var close = t.closest('.slm-compat-options-close');
      if (close) { e.preventDefault(); close.closest('.slm-compat-options').hidden = true; return; }
      var opt = t.closest('.slm-compat-option');
      if (opt) {
        e.preventDefault();
        if (opt.disabled) return;
        var ctaO = opt.closest('.slm-compat-cta');
        ctaO.setAttribute('data-variant-id', opt.getAttribute('data-variant-id'));
        opt.closest('.slm-compat-options').hidden = true;
        quickAdd(opt.getAttribute('data-variant-id'), ctaO);
        return;
      }
      var add = t.closest('.slm-compat-add');
      if (add && !add.disabled) {
        e.preventDefault();
        var ctaA = add.closest('.slm-compat-cta');
        if (ctaA && ctaA.getAttribute('data-variant-id')) quickAdd(ctaA.getAttribute('data-variant-id'), ctaA);
        return;
      }
      var step = t.closest('.slm-compat-step');
      if (step) {
        e.preventDefault();
        var ctaS = step.closest('.slm-compat-cta');
        var inp = ctaS.querySelector('.slm-compat-qty');
        var cur = inp ? (parseInt(inp.value, 10) || 0) : 0;
        changeQty(ctaS.getAttribute('data-variant-id'), cur + parseInt(step.getAttribute('data-step'), 10), ctaS);
      }
    });
    root.addEventListener('change', function (e) {
      var inp = e.target.closest('.slm-compat-qty');
      if (!inp) return;
      var cta = inp.closest('.slm-compat-cta');
      var n = parseInt(inp.value, 10);
      if (isNaN(n) || n < 0) n = 0;
      changeQty(cta.getAttribute('data-variant-id'), n, cta);
    });
    Array.prototype.forEach.call(root.querySelectorAll('.slm-compat-carousel'), initCarousel);
    initTabs(root);
  }

  /* ---------- Onglets ---------- */
  function hydrate(pan) {
    var tpl = pan.querySelector('template[data-slm-lazy]');
    if (!tpl) return;
    tpl.parentNode.replaceChild(tpl.content.cloneNode(true), tpl);
    applyTax();
    syncCtas();
  }
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var voir = root.querySelector('[data-slm-voir]');
    if (tabs.length < 2) return;
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var pan = document.getElementById(t.getAttribute('aria-controls'));
        if (on && pan) hydrate(pan);
        if (pan) pan.hidden = !on;
        if (on && pan) { var tr = pan.querySelector('[data-slm-track]'); if (tr) { tr.scrollLeft = 0; tr.dispatchEvent(new Event('scroll')); } }
      });
      if (voir && tab.getAttribute('data-url')) voir.setAttribute('href', tab.getAttribute('data-url'));
      if (focus) tab.focus();
      if (tab.scrollIntoView && tab.parentNode.scrollWidth > tab.parentNode.clientWidth) {
        tab.parentNode.scrollTo({ left: tab.offsetLeft - 16, behavior: 'smooth' });
      }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight') j = (i + 1) % tabs.length;
        else if (k === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') j = 0;
        else if (k === 'End') j = tabs.length - 1;
        if (j > -1) { e.preventDefault(); select(tabs[j], true); }
      });
    });
  }

  /* ---------- Carrousel ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-slm-track]');
    var prev = root.querySelector(':scope > .slm-compat-arrow--prev');
    var next = root.querySelector(':scope > .slm-compat-arrow--next');
    if (!track) return;
    function stepPx() {
      var card = track.querySelector('.slm-compat-card');
      var gap = parseInt(getComputedStyle(track).columnGap, 10) || 14;
      var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      return w * Math.max(1, Math.floor((track.clientWidth + gap) / w));
    }
    var bar = root.querySelector('.slm-home__progress');
    function update() {
      var overflow = track.scrollWidth > track.clientWidth + 2;
      if (bar) {
        bar.hidden = !overflow;
        var w = track.clientWidth / track.scrollWidth;
        var max = track.scrollWidth - track.clientWidth;
        var l = max > 0 ? (track.scrollLeft / max) * (1 - w) : 0;
        bar.style.setProperty('--w', (w * 100).toFixed(2) + '%');
        bar.style.setProperty('--l', (l * 100).toFixed(2) + '%');
      }
      if (prev) prev.hidden = !overflow || track.scrollLeft <= 8;
      if (next) next.hidden = !overflow || track.scrollLeft >= track.scrollWidth - track.clientWidth - 8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepPx(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepPx(), behavior: 'smooth' }); });
    var raf = 0;
    function schedule() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; update(); }); }
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    schedule();
    setTimeout(schedule, 400);
  }


  function init() {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-slm-home-produits]'));
    roots.forEach(bind);
    applyTax();
    var rerun = applyTax;
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.slm-compat-options') && !e.target.closest('.slm-compat-add--choose')) closeAll(null);
    });
    var tg = document.getElementById('taxToggleAll');
    if (tg) tg.addEventListener('change', function () { setTimeout(rerun, 0); });
    if (!roots.length) return;
    document.addEventListener('ajaxProduct:added', function () { setTimeout(function () { refreshCartMap().then(syncCtas); }, 400); });
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };
    idle(function () { refreshCartMap().then(syncCtas); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
